import { z } from 'zod';
import { productConfigSchema } from '../model';
import { UseFormReturn } from 'react-hook-form/dist/types/form';
import { CriteriaValue } from 'modules/jsonRulesCriterias/businessCriteria/types';
import { ListingForm } from 'components/shared/TableListing/types';
import { AftermarketProductType, Document } from '@trnsact/trnsact-shared-types';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { MARKUP_TYPE } from '@trnsact/business-criteria/dist/src/models/rule-event/aftermarket/markup-type';

export type ProductConfig = z.infer<typeof productConfigSchema>;

export interface ProductConfigListingContext {
  isReadOnly: boolean;
  form: UseFormReturn<ListingForm<ProductConfig>>;
  handleCopyLastConfig: VoidFunction;
  onAddConfigurationColumn: VoidFunction;
  handleRemoveRow: (index: number) => void;
  handleAddRow: (row: ProductConfig) => void;
  handleRemoveColumn: (index: number) => void;
}

export interface FactNumericType {
  value: FACT_NAMES_NUMERIC;
  label: string;
}

export interface FactBooleanType {
  value: FACT_NAMES_BOOLEAN;
  label: string;
}

export interface FactStringType {
  value: FACT_NAMES_STRING;
  label: string;
}

export interface PricingProductConfiguration {
  dealerCost: number;
  rateFactor: number;
  minPricing: number;
  maxPricing: number;
  dealerMarkup: number;
  dealerMarkupType: MARKUP_TYPE;
  suggestedRetailPricing: number;
}

export interface Configuration extends PricingProductConfiguration {
  id?: string;
  name: string;
  dealerCostSource?: string;
  type?: AftermarketProductType;
  configRows: CriteriaValue[];
}

export enum AftermarketProductConfigTabs {
  Base = 'base',
  Addons = 'addons',
  ProductCatalog = 'productCatalog',
}

export interface ProductPageDocumentsState {
  initialDocuments: Document[];
  documentsToAdd: File[];
  documentsToRemove: Document[];
}

export interface DocumentListItemProps {
  canWrite: boolean;
  document: File | Document;
  documentName: string;
  onDelete: (document: File | Document) => void;
}

export enum EditRestrictionReason {
  SHARED_PRODUCT = 'sharedProduct',
  LICENSE_TYPE = 'licenseType',
  USER_ROLE = 'userRole',
}
